import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { CIRCUIT_FLIGH_PARAMS_MODULE, DEFAULT_COLUMN } from "../constants/flightParamsConstants";

export const setFlightParamsPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: CIRCUIT_FLIGH_PARAMS_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
